"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Separator: true
};
exports.default = exports.Separator = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _MenuButtonItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MenuButtonItem.css") : void 0);
var _Separator = require("./Separator.types");
Object.keys(_Separator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Separator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Separator[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-menu-button-item';
const Separator = exports.Separator = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      className
    } = props,
    itemProps = __rest(props, ["className"]);
  const classnames = _bind.default.bind(_MenuButtonItem.default);
  return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, itemProps, {
    ref: ref,
    role: "separator",
    "aria-hidden": true,
    "data-nui-widgets": "menuitem-leaf",
    className: classnames(className, `${CSS_BLOCK}__separator`)
  }));
});
Separator.displayName = 'Separator';
var _default = exports.default = Separator;